'use client';

import { c as _c } from "react/compiler-runtime";
import { documentoHtmlIsolado, ESTILOS_PREVIEW_DOCUMENTO } from '@/shared/utils/documentoHtmlIsolado';
interface PreviewHtmlSandboxProps {
  titulo: string;
  html: string;
  estilos?: string;
  sandbox?: string;
  className?: string;
}

/**
 * Renderiza HTML de origem não confiável — derivado de arquivo do usuário
 * (docx/planilha convertidos) ou renderizado pelo back (folha do modelo) — num
 * iframe isolado por duas barreiras complementares.
 *
 * O `sandbox` vazio do default impede script e navegação do documento — só
 * alargue quando o conteúdo for confiável e a funcionalidade exigir, declarando
 * o motivo no call-site.
 *
 * O `sandbox`, porém, **não** impede requisição de subrecurso: uma `<img>` com
 * `src` remoto sobrevive à sanitização e vazaria IP e User-Agent de quem abre o
 * documento para um terceiro. O CSP do documento fecha isso:
 *
 * - `default-src 'none'` — nada carrega por default; é o que barra o beacon;
 * - `img-src data: blob:` — o mammoth embute as imagens do docx como data URI,
 *   então elas precisam passar; `https:` fica fora de propósito, é o vetor;
 * - `style-src 'unsafe-inline'` — o `<style>` e os `style=` que este componente
 *   e o grid da planilha injetam;
 * - `font-src data:` — a folha do modelo embute a fonte como data URI; `https:`
 *   fica fora de propósito pelo mesmo motivo do `img-src`, é o vetor de beacon.
 *
 * O `estilos` é interpolado cru dentro do `<style>`: um `</style>` no CSS fecha o
 * elemento e injeta markup no documento do iframe. É aceitável porque o dano para
 * no próprio iframe — `sandbox=""` sem `allow-scripts` e `default-src 'none'`
 * impedem script e subrecurso remoto —, e não vale o custo de um parser de CSS.
 */
export function PreviewHtmlSandbox(t0) {
  const $ = _c(8);
  const {
    titulo,
    html,
    estilos: t1,
    sandbox: t2,
    className
  } = t0;
  const estilos = t1 === undefined ? ESTILOS_PREVIEW_DOCUMENTO : t1;
  const sandbox = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== estilos || $[1] !== html) {
    t3 = documentoHtmlIsolado(html, {
      estilos
    });
    $[0] = estilos;
    $[1] = html;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = className ?? "h-full w-full rounded-lg border-0 bg-white";
  let t5;
  if ($[3] !== sandbox || $[4] !== t3 || $[5] !== t4 || $[6] !== titulo) {
    t5 = <iframe title={titulo} sandbox={sandbox} srcDoc={t3} className={t4} />;
    $[3] = sandbox;
    $[4] = t3;
    $[5] = t4;
    $[6] = titulo;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}